module.exports = __webpack_public_path__ + "static/Dial_front-c233d0f1ff53227f5416af5dc83e6193.jpg";